<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="content_category rounded-lg">
          <v-col cols="12" >
            <v-textarea
                class="content-textarea"
                background-color="#EDF2F7"
                label="Mô tả ngắn"
                v-model="content"
                placeholder="Nhập mô tả ngắn"
            >
            </v-textarea>
          </v-col>
          <v-col cols="12">
            <v-select
              background-color="#EDF2F7"
              filled
              item-text="text"
              v-model="type"
              :items="types"
              item-value="id"
              label="Chọn loại Link"
            ></v-select>
          </v-col>
          <v-col cols="12" v-show="type == 2">
            <v-text-field
              background-color="#EDF2F7"
              filled
              v-model="link.url"
              item-text="name"
              item-value="id"
              label="Nhập đường dẫn"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-show="type == 1">
            <v-select
              background-color="#EDF2F7"
              filled
              item-text="name"
              v-model="link.type"
              :items="modlues"
              item-value="id"
              label="Chọn loại"
            ></v-select>
          </v-col>
          <v-col cols="12" v-show="type == 1">
            <v-autocomplete
              background-color="#EDF2F7"
              filled
              v-model="link.object_id"
              item-text="name"
              item-value="slug"
              :items="list_ids"
              label="Chọn ID"
            ></v-autocomplete>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { GET_LIST_TAG } from "@/store/modules/tag";
import { GET_CONFIG_ABOUT, UPDATE_CONFIG_ABOUT } from "@/store/modules/configs";

export default {
  data() {
    return {
      content: null,
      type: null,
      link: {
          brand_slug: null,
          type: null,
          object_id: null,
          url: null,
      },
      list_ids: [],
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      modlues: [
        {
          id: "category",
          name: "category",
        },
        {
          id: "brand",
          name: "brand",
        },
        {
          id: "tag",
          name: "tag",
        },
      ],
      page: "Về chúng tôi",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Về chúng tôi",
          disabled: true,
        },
      ],
    };
  },
  watch: {
    type(value){
      if(value == 1){
        this.link.url = null;
      }
      if(value == 2){
        this.link.type = null;
        this.link.object_id = null;
      }
    },
    ['link.type'](value){
      this.setListByType(value);
    },
    config_about(value){
      if(typeof value == 'object' && value !== null){
        this.content = value.content
        this.type = value.type
        this.link = {
          brand_slug: value.link.brand_slug ?? null,
          type: value.link.type ?? null,
          object_id: value.link.object_id ?? null,
          url: value.link.url ?? null
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      config_about: "config_about",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_CONFIG_ABOUT}`);
    
  },
  methods: {
    setListByType(value){
      const _this = this;
      let url = "";
      if(value == "category"){
        url = GET_LIST_CATEGORY;
      }
      if(value == "brand"){
        url = GET_LIST_BRAND;
      }
      if(value == "tag"){
        url = GET_LIST_TAG;
      }
      if (url != "") {
        this.$store.dispatch(url).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
    save() {
      this.updateLink();
      let param = {
        content: this.content,
        type: this.type,
        link: this.link
      };
      this.$store
        .dispatch(`${UPDATE_CONFIG_ABOUT}`, param)
        .then((data) => {
          if (data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              position: "top-center",
              duration:2000,
            })
            this.$router.push("/manage_page/Config_about");
          } else {
            alert(data.data.errors);
          }
        });
    },
    updateLink(){
      this.link.brand_slug = null;
      if(this.link.type == "category"){
        let category = this.list_ids.find(item =>{
          return item.slug == this.link.object_id
        })
        this.link.brand_slug = category.brand_slug;
      }
    }
  },
};
</script>

<style lang="scss" scope>
  .content_category {
    background: #ffffff !important;
    .v-input__control {
      height: 65px !important;
    }
    .content-textarea .v-input__control {
      height: 165px !important;
    }
  }
  .v-text-field > .v-input__control > .v-input__slot{
    padding-left: 12px;
    padding-top: 20px
  }
</style>